import { inject } from 'tsyringe'
import { Merge } from 'type-fest'
import Vue from 'vue'
import { containerScoped } from '~/decorators/dependency-container'
import { RefType } from '~/models/event/builder'
import {
  HeaderDropdownLink,
  HeaderDropdownId
} from '~/models/header/header-dropdown'
import Base64Service from '~/services/Base64Service'
import EventBuilder from '~/builders/event/EventBuilder'

@containerScoped()
export default class HeaderDropdownService {
  /* eslint-disable camelcase */
  constructor(
    @inject(Base64Service) private base64Service: Base64Service,
    @inject(EventBuilder) private eventCreator: EventBuilder
  ) {}

  getLinkHash({ title, url, icon, extra_classes }: HeaderDropdownLink): string {
    return this.base64Service.toBase64(
      title + url + extra_classes + (icon ? icon.name : '')
    )
  }

  createElementDropdownEventListeners(componentInstance: Vue) {
    const c = componentInstance as Merge<
      Vue,
      { shownDropdowns: Set<HeaderDropdownId> }
    >
    const dropdownRefToId: Array<[() => RefType, HeaderDropdownId]> = [
      [() => c.$refs.localeDropdown, HeaderDropdownId.LOCALE],
      [() => c.$refs.userDropdown, HeaderDropdownId.USER],
      [() => c.$refs.myClassifiedsDropdown, HeaderDropdownId.MY_CLASSIFIEDS],
      [
        () => c.$refs.userRegistrationDropdown,
        HeaderDropdownId.USER_REGISTRATION
      ]
    ]
    c.$nextTick(() => {
      for (const [refGetter, dropdownId] of dropdownRefToId) {
        if (!refGetter()) {
          continue
        }

        this.eventCreator
          .hover(refGetter)
          .setComponent(c)
          .onEnter(() => {
            const shownDropdowns = new Set(c.shownDropdowns)
            shownDropdowns.add(dropdownId)
            c.shownDropdowns = shownDropdowns
          })
          .onLeave(() => {
            const shownDropdowns = new Set(c.shownDropdowns)
            shownDropdowns.delete(dropdownId)
            c.shownDropdowns = shownDropdowns
          })
          .build()
      }
    })
  }
}
